
export default {
  head() {
    return {
      title:
        "Agence Google Ads | SEA à Saint-Pierre dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads à Saint-Pierre certifiée Google Partner, soutient les entreprises saint-pierroises pour accroître leur visibilité en ligne et conquérir de nouveaux clients.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Agence Google Ads à Saint-Pierre dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads à Saint-Pierre certifiée Google Partner, soutient les entreprises saint-pierroises pour accroître leur visibilité en ligne et conquérir de nouveaux clients.",
        },
      ],
    };
  },
};
